// import React from 'react';

// const PaymentSuccessPage = () => {
//     return (
//         <div>
//             <h1>Payment Successful!</h1>
//             <p>Thank you for your payment. Your transaction has been completed successfully.</p>
//             <p>You can now access the premium features.</p>
//         </div>
//     );
// };

// export default PaymentSuccessPage;

import React, { useEffect ,useState} from 'react';
import Header from './Header';
import { useNavigate , useLocation ,useSearchParams} from 'react-router-dom';
import { toast } from 'react-toastify';
// Import handleUpgrade from PointScreen or move it to a shared utils file
import { handleUpgrade } from './PointScreen'; // If exported separately


const StripeSuccessPage = (props) => {
  const navigate = useNavigate();
     const [searchParams] = useSearchParams();

  //  const serverUrl = 'http://localhost:5000'; 
  //  const serverUrl = "http://192.168.10.167:8000";
  //  const serverUrl = "https://flowmap.uvjtech.in";
  //  const serverUrl = "https://flowmap.uvjtech.in";
   const serverUrl = "https://beta.flowlogic.com";
   

  const [verifying, setVerifying] = useState(true);
     const [paymentDetails, setPaymentDetails] = useState(null);
     const [error, setError] = useState(null);
        const token = localStorage.getItem('authToken');
       

  useEffect(() => {
    // Call upgrade logic after Stripe payment success
    // handleUpgrade();
     localStorage.setItem('isSubscribed', 'true');
  }, []);



      useEffect(() => {
  const verifyPayment = async () => {
    const sessionId = searchParams.get('session_id');
    console.log('Session ID:', sessionId);

    // if (!sessionId) {
    //   setError('No session ID found');
    //   setVerifying(false);
    //   return;
    // }

    try {
      console.log('Verifying payment with session ID:', sessionId);
      const response = await fetch(`${serverUrl}/api/subscriptions/verify-session/${sessionId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      const data = await response.json();
      console.log('Verification response:', data);

      if (response.ok) {
        setPaymentDetails(data);

        localStorage.setItem('isSubscribed', 'true');
        localStorage.setItem('subscriptionType', 'premium');
        localStorage.setItem('paymentDate', new Date().toISOString());

        toast.success('Payment verified successfully!');
      } else {
        setError(data.error || 'Verification failed');
      }
    } catch (err) {
      console.error('Payment verification failed:', err);
      setError('Network error during verification');
    }

    setVerifying(false);
  };

  verifyPayment();
// }, [searchParams]);
}, []);

      

  return (
    <div>
      <Header
        activeTab="all"
        showSearch={false}
        showFavorites={false}
        showLinks={false}
        isSubscribed={true}
      />
      {verifying ? (
  <p>Verifying payment...</p>
) : error ? (
  <p style={{ color: 'red' }}>{error}</p>
) : (
      <div style={{ textAlign: 'center', marginTop: '80px' }}>
        <h2> Payment Successful!</h2>
        <p>Your subscription has been upgraded. Welcome to FlowLogic Pro!</p>
        <button
          style={{
            marginTop: '30px',
            padding: '10px 30px',
            background: '#1c8f7d',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            cursor: 'pointer'
          }}
          onClick={() => navigate('/dashboard')}
          // onClick={() => navigate('/points')}
        >
          Go to Dashboard
        </button>
      </div>
    )}
    </div>
  );
};

export default StripeSuccessPage;